export enum UserRoles {
    admin = "ROLE_ADMIN", 
    userManager = "ROLE_USER_MANAGER", 
    user = "ROLE_USER", 
    viewOnly = "ROLE_VIEW_ONLY", 
    config = "ROLE_CONFIG_USER", 
    system = "ROLE_SYSTEM"
}